import { ToggleButtonProps, ToggleButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ToggleButtonStyled = styled(ToggleButton)<ToggleButtonProps>(({ theme }) => ({
  '&.MuiToggleButton-root': {
    borderRadius: '25px',
    borderColor: theme.palette.border?.primary,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
    '&.Mui-selected, &.Mui-selected:hover': {
      color: theme.palette.tertiary.contrastText,
      backgroundColor: theme.palette.tertiary.main,
    },
    '&:hover': {
      '@media (hover: none)': {
        color: theme.palette.tertiary.light,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
      },
    },
    color: theme.palette.text.primary,
  },
  '&.MuiToggleButton-sizeSmall': {
    padding: `${theme.spacing(0)} ${theme.spacing(1)}`,
  },
  '&.MuiToggleButton-sizeLarge': {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
}));
